/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Is_UnassignedInputs */

const en_filter_is_unassigned = /** @type {(inputs: Filter_Is_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unassigned`)
};

const de_filter_is_unassigned = /** @type {(inputs: Filter_Is_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nicht zugewiesen`)
};

/**
* | output |
* | --- |
* | "unassigned" |
*
* @param {Filter_Is_UnassignedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_is_unassigned = /** @type {((inputs?: Filter_Is_UnassignedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Is_UnassignedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_is_unassigned(inputs)
	return en_filter_is_unassigned(inputs)
});